import { gql } from "@apollo/client";
 

export const STRIVE_FEES_QUERY = gql`
query StriveFees($params: striveFeesParams) {
  striveFees(params: $params) {
    success
    message
    data {
      ARCIMEDES_ROW_ID
      NAME
      CITY
      STATE
      TRANSACTION_TYPE
      CLOSE_OF_ESCROW
      TOTAL_FEE
      TOTAL_FEE1
      LISTING_AGENT_1_LAST_NAME
      LISTING_AGENT_1_PERCENT
      LISTING_AGENT_2_LAST_NAME
      LISTING_AGENT_2_PERCENT
      LISTING_AGENT_3_LAST_NAME
      BUYER_AGENT_1_LAST_NAME
      BUYER_AGENT_1_PERCENT
      BUYER_AGENT_2_LAST_NAME
      BUYER_AGENT_2_PERCENT
      BUYER_AGENT_3_LAST_NAME
      BUYER_AGENT_3_PERCENT
      BUYER_AGENT_4_LAST_NAME
      BUYER_AGENT_4_PERCENT
      REFERRAL_FEE
    }
    error
  }
}
`

export const GET_TEAMMEMBER_StRIVE_FEES = gql`
query GetTeamMember($arcimedesRowId: ID!) {
  getTeamMember(arcimedes_row_id: $arcimedesRowId) {
    arcimedes_row_id
    first_name
    last_name
    title
    phone
    linkedin
    email
    description
    photo
    credentials
    is_agent
    deleted
    is_admin
    visible_on_website
    starting_date
    termination_date
    yrs_at_strive
    birth_date
    age
    on_phones
    in_pool
    first_listing
    first_closing
    address
    city
    state
    zip
    cell_phone
    territory
    w4_form
    w9_form
    payroll_form
    ca_form
    it_policy_form
    trade_secrets_form
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
  }
}
`


export const GET_ALL_TEAM_MEMBERS_DATA = gql`
query GetAllTeamMembers($filters: [Filters]) {
  getAllTeamMembers(filters: $filters) {
    arcimedes_row_id
    first_name
    last_name
    title
    phone
    linkedin
    email
    description
    photo
    credentials
    is_agent
    deleted
    is_admin
    visible_on_website
    starting_date
    termination_date
    yrs_at_strive
    birth_date
    age
    on_phones
    in_pool
    first_listing
    first_closing
    address
    city
    state
    zip
    cell_phone
    territory
    w4_form
    w9_form
    payroll_form
    ca_form
    it_policy_form
    trade_secrets_form
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
  }
}
`